module.exports = __webpack_public_path__ + "assets/img/Instagram.44053cd3.svg";